import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const AnchorIconGrayscale = (props)=>/*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        width: "24",
        height: "22",
        viewBox: "0 0 24 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs("g", {
                style: {
                    mixBlendMode: 'luminosity'
                },
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M18.0656 21.0088C20.7104 21.4791 24.0001 15.8506 24.0001 15.8506L17.711 16.2685C16.9019 18.6634 16.7149 20.4495 18.0656 21.0088Z",
                        fill: "url(#paint0_linear_5620_94519)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M18.154 2.68874C17.5672 1.81208 17.776 1.72265 16.6897 1.5547C16.3448 1.50268 16.1247 0.240612 12.9101 1.9374C8.61483 4.20374 1.76004 11.9592 0 14.3402L8.37978 13.7834C10.2808 11.5086 14.0858 7.24594 16.3168 6.10755C17.7955 5.06222 18.9235 3.83973 18.154 2.68874Z",
                        fill: "url(#paint1_linear_5620_94519)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M20.2151 10.6564C20.3414 10.3695 20.4549 10.1523 20.5133 10.0105C21.6718 7.17601 23.0011 5.23444 21.2523 3.11247C20.0599 1.6659 16.8426 0.231213 14.1035 1.38329C15.2626 1.13451 16.1392 1.21548 16.7035 2.06369C17.6946 3.55455 15.63 6.71203 14.8672 8.36075C14.0592 10.1069 13.1794 11.8291 12.5945 13.6699C12.1714 15.0036 11.8211 16.7095 12.7542 17.9134C13.5622 18.9555 15.86 20.2066 16.4993 20.4863C17.046 20.7252 17.6312 20.9867 18.2317 21.0299C15.7816 20.0323 18.543 14.4467 20.2151 10.6564Z",
                        fill: "url(#paint2_linear_5620_94519)"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_5620_94519",
                        x1: "13.7126",
                        y1: "19.4446",
                        x2: "27.2569",
                        y2: "15.1262",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.18",
                                stopColor: "#4A0D73"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.277",
                                stopColor: "#7C2091"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.374",
                                stopColor: "#A731AB"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.461",
                                stopColor: "#C53DBD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.535",
                                stopColor: "#D845C8"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.586",
                                stopColor: "#DF48CD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_5620_94519",
                        x1: "21.605",
                        y1: "1.43997",
                        x2: "-3.88371",
                        y2: "30.0776",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.045",
                                stopColor: "#001480",
                                stopOpacity: "0.898"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.079",
                                stopColor: "#063194",
                                stopOpacity: "0.918"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.162",
                                stopColor: "#1673C1",
                                stopOpacity: "0.953"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.233",
                                stopColor: "#21A3E2",
                                stopOpacity: "0.976"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.286",
                                stopColor: "#28C1F7",
                                stopOpacity: "0.992"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.316",
                                stopColor: "#2BCDFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.429",
                                stopColor: "#3EDBDB"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.562",
                                stopColor: "#52EAB7"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.634",
                                stopColor: "#5AF0AA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint2_linear_5620_94519",
                        x1: "5.41861",
                        y1: "33.1498",
                        x2: "35.8177",
                        y2: "18.6498",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.423",
                                stopColor: "#643CFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.609",
                                stopColor: "#7268FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.774",
                                stopColor: "#7D89FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.865",
                                stopColor: "#8296FF"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
